const listeners = new Set();
let deferredPrompt = null;
let installed = false;
let dismissedAt = 0;

const isStandalone = () => (typeof window !== "undefined" && (window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true)) || false;

const emit = () => listeners.forEach((listener) => listener(getInstallState()));

export const getInstallState = () => ({
  canPrompt: Boolean(deferredPrompt),
  installed: installed || isStandalone(),
  standalone: isStandalone(),
  dismissedAt,
});

export const subscribeInstallState = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const initInstallManager = () => {
  if (typeof window === "undefined") {
    return;
  }
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event;
    emit();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    installed = true;
    emit();
  });
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js").catch(() => null);
    });
  }
};

export const promptInstall = async () => {
  if (!deferredPrompt) {
    return { outcome: "unavailable" };
  }
  const promptEvent = deferredPrompt;
  deferredPrompt = null;
  emit();
  promptEvent.prompt();
  const choice = await promptEvent.userChoice;
  if (choice.outcome !== "accepted") {
    dismissedAt = Date.now();
  }
  emit();
  return choice;
};

export const browserInstallHint = () => {
  const agent = typeof navigator === "undefined" ? "" : navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(agent)) {
    return "In Safari tap Share, then \"Add to Home Screen\".";
  }
  if (/Safari/i.test(agent) && !/Chrome|Chromium|Edg/i.test(agent)) {
    return "In Safari choose File → \"Add to Dock…\" to install Lumen TMS as an app.";
  }
  if (/Firefox/i.test(agent)) {
    return "Firefox does not support desktop app installs yet — open Lumen TMS in Chrome or Edge and click Install.";
  }
  return "Open the browser menu (⋮) and choose \"Install Lumen TMS\" or \"Add to Dock\". Chrome shows the install icon in the address bar after you have used the app for a moment.";
};
